import { Channel } from '../channels/Channel';
import { ApplicationUser } from './ApplicationUser';

export class IdentityToken {
  expires: string;
  access_token: string;
  refresh_token: string;
  user: ApplicationUser;
  channel?: Channel;
}
